import React from "react";
import Navbar from "../components/NavBar";
import useEasterEggs from "../hooks/useEasterEggs";
import korea from "../images/korea.png";

function AboutMe() {
  const { handleShiftHover } = useEasterEggs();

  return (
    <div className="container">
      <Navbar />

      <div className="page-content introduction-container">
        <h1
          className="introduction-title has-secret-message"
          onMouseEnter={handleShiftHover(
            "Founded in the Joseon Dynasty, still delicious today!",
          )}
        >
          Hello!
        </h1>
        <div className="image-container">
          <img src={korea} alt="Korea" className="korea-image" />
        </div>
        <div className="introduction-content">
          <p>
            <br />
            <br />
            Annyeonghaseyo, dear food lovers!
            <br />
            <br />
            Let me whisk you away on a delightful journey through the vibrant
            tapestry of my history.
            <br />
            <br />
            I am the cheerful and ever-delicious Happy Bibimbap, a beloved icon
            of Korean cuisine, ready to share my flavorful saga.
            <br />
            <br />
            Picture this: Korea, a land steeped in rich traditions and vibrant
            culture.
            <br />
            <br />
            It was during the late Joseon Dynasty (조선왕조) that my story
            began.
            <br />
            <br />
            Imagine bustling marketplaces, fragrant with the aroma of freshly
            cooked rice, where inventive cooks began mixing leftovers into a
            harmonious bowl of goodness.
            <br />
            <br />
            The early iterations of what would become known as bibimbap (비빔밥)
            were simple yet ingenious, combining rice with an array of seasonal
            vegetables, meats, and the occasional egg.
            <br />
            <br />
            This practice of goldongban (골동반) was a testament to the
            resourcefulness and creativity of Korean cooks, ensuring that no
            morsel went to waste.
            <br />
            <br />
            By the 19th century, I had evolved into a culinary staple, cherished
            by both royalty and commoners alike.
            <br />
            <br />
            My name, meaning "mixed rice," began to resonate with the spirit of
            togetherness and unity.
            <br />
            Each ingredient in my bowl, whether it be the earthy spinach, the
            sweet carrots, or the spicy gochujang (고추장), contributed its own
            unique flavor to the symphony.
            <br />
            <br />
            Let me paint a picture for you: a steaming bowl, brimming with
            colorful vegetables, tender slices of beef, and a sprinkle of sesame
            seeds.
            <br />
            At my heart, a perfectly cooked egg, its yolk a golden sun bringing
            warmth and unity to the dish.
            <br />
            <br />
            I, Happy Bibimbap, am not just a meal but a celebration of harmony
            and balance.
            <br />
            <br />
            Every bite tells a story of tradition, innovation, and the joyous
            spirit of Korean hospitality.
            <br />
            <br />
            So, dear friends, as you dig into my delightful blend of textures
            and flavors, remember that you are savoring a piece of history, a
            culinary tale that has traveled through centuries to bring joy to
            your palate.
            <br />
            <br />
            Welcome to my world, where every mouthful is a testament to the
            beauty of Korean cuisine, and every meal is a festive occasion.
            <br />
            <br />
            Enjoy, and let the flavors of Happy Bibimbap fill your heart with
            joy and your soul with satisfaction!
            <br />
            <br />
          </p>
        </div>
      </div>
    </div>
  );
}

export default AboutMe;
